/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TextField, Typography, Grid, MenuItem } from '@mui/material';
import {
  GeneralModal,
  ModalButton,
  OutlinedButton,
  SelectDropdown,
} from '../index';
import { useState } from 'react';

export const CustomRangeModal = (props) => {
  const [selected, setSelected] = useState('pre-defined');

  return (
    <GeneralModal
      open={props.open}
      onClose={props.onClose}
      style={{ width: '30%' }}
    >
      <Typography sx={{ mb: 0.5, fontWeight: 600 }} variant="h5">
        Select an option:
      </Typography>
      {props.showOptions ? (
        <Grid container spacing={2} sx={{ mt: 0, mb: 2 }}>
          <Grid item xs={6}>
            <OutlinedButton
              fullWidth
              btnTitle="Pre-defined Date Range"
              onClick={() => setSelected('pre-defined')}
              style={{
                bgcolor: selected === 'pre-defined' ? '#84D8C5' : 'none',
                color: selected === 'pre-defined' ? '#FFF' : '#84D8C5',
                '&:hover': {
                  color: '#FFF',
                  borderColor: '#84d8c5',
                  bgcolor:
                    selected === 'pre-defined'
                      ? '#84d8c5'
                      : 'rgb(132, 216, 197, 0.2) !important',
                },
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <OutlinedButton
              fullWidth
              btnTitle="Custom Date Range"
              onClick={() => setSelected('custom')}
              style={{
                bgcolor: selected === 'custom' ? '#84D8C5' : 'none',
                color: selected === 'custom' ? '#FFF' : '#84D8C5',
                '&:hover': {
                  color: '#FFF',
                  borderColor: '#84d8c5',
                  bgcolor:
                    selected === 'custom'
                      ? '#84d8c5'
                      : 'rgb(132, 216, 197, 0.2) !important',
                },
              }}
            />
          </Grid>
        </Grid>
      ) : (
        <></>
      )}
      {selected === 'pre-defined' && props.showOptions ? (
        <SelectDropdown
          required={true}
          sx={{ minWidth: 200 }}
          label="Date Range"
          margin="normal"
          fullWidth
          value={props.dateRange}
          onChange={props.handleDateRangeChange}
        >
          <MenuItem value={'currentMonth'}>Current Month</MenuItem>
          <MenuItem value={'previousCutoff'}>Previous Cutoff</MenuItem>
          <MenuItem value={'3months'}>Last 3 months</MenuItem>
          <MenuItem value={'6months'}>Last 6 months</MenuItem>
          <MenuItem value={'1year'}>Last 1 year</MenuItem>
          <MenuItem value={'2years'}>Last 2 years</MenuItem>
        </SelectDropdown>
      ) : (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            required={true}
            label="Start Date"
            value={props.startValue}
            onChange={props.startOnChange}
            maxDate={props.endValue}
            renderInput={(params) => (
              <TextField margin="normal" required fullWidth {...params} />
            )}
          />
          <DatePicker
            required={true}
            label="End Date"
            value={props.endValue}
            onChange={props.endOnChange}
            minDate={props.startValue}
            renderInput={(params) => (
              <TextField margin="normal" required fullWidth {...params} />
            )}
          />
        </LocalizationProvider>
      )}
      <ModalButton
        disable={!(props.endValue && props.startValue)}
        primaryBtnName="Save"
        secondaryBtnName="Cancel"
        secondaryClickHandler={props.secondaryClick}
        primaryClickHandler={props.primaryClick}
        style={{ mt: 3 }}
      />
    </GeneralModal>
  );
};
